<template>
  <div>
    <title-bar :title-stack="titleStack"/>
    <hero-bar>
      Carga de Usuarios
    </hero-bar>
    <section class="section is-main-section">

      <card-component class="tile is-child">
        <b-field vertical>
          <b>Descarga la plantilla para realizar la carga de usuarios</b>
        </b-field>
        <tiles>
            <download-template/>
            <upload-template/>
        </tiles>
      </card-component>
    </section>
  </div>

</template>

<script>
import CardComponent from '@/components/CardComponent'
import TitleBar from '@/components/TitleBar'
import Tiles from '@/components/Tiles'
import HeroBar from '@/components/HeroBar'
import DownloadTemplate from '@/components/userload/DownloadTemplate'
import UploadTemplate from '@/components/userload/UploadTemplate'

export default {
  name: 'UserLoad',
  components: { HeroBar, TitleBar, CardComponent, Tiles, DownloadTemplate, UploadTemplate },
  computed: {
    titleStack () {
      return [
        'Admin'
      ]
    }
  }
}
</script>
